// =============================================================================
// MCEVENTS - Event Constants (replaces mc-events.js from ict-shopify)
// =============================================================================
window.MCEVENTS = {
	CART_ADDED: 'mc:cart:added',
	CART_UPDATED: 'mc:cart:updated',
	CART_ERROR: 'mc:cart:error'
};

// =============================================================================
// Utility: getShopifyRoot - Normalizza Shopify.routes.root con slash finale
// Necessario perché alcuni market restituiscono '/it-it' senza slash finale
// =============================================================================
window.getShopifyRoot = function() {
	const root = Shopify?.routes?.root || '/';
	return root.endsWith('/') ? root : `${root}/`;
};

// =============================================================================
// nativeFetch - Bypass  dell'hijack di window.fetch da parte di app di
// terze parti (es. Restockrocket) che intercettano le chiamate cart API e
// possono corrompere le response (es. {items: []}).
// Usare al posto di window.fetch solo se assolutamente necessario
// =============================================================================
// const nativeFetch =  window.fetch.bind(window);

// =============================================================================
// McShopify - Native Cart & Privacy API (replaces mc-shopify.js from ict-shopify)
// =============================================================================
class McShopify {

	// Custom event dispatcher (used by cart methods)
	static customEvent(eventName, data) {
		const event = new CustomEvent(eventName, { detail: data });
		window.dispatchEvent(event);
		if (typeof Shopify !== 'undefined' && Shopify.analytics) {
			Shopify.analytics.publish(eventName, data);
		}
	} 

	// Add products to cart
	static addToCart({ items, onSuccess, onError, onComplete }) {
		window.LOG?.group?.('[McShopify] addToCart');
		window.LOG?.info?.('Items being sent to /cart/add.js:', items);
		window.LOG?.debug?.('URL:', `${window.getShopifyRoot()}cart/add.js`);

		fetch(`${window.getShopifyRoot()}cart/add.js`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ items })
		})
			.then(async r => {
				const responseText = await r.text();
				window.LOG?.debug?.('Raw response status:', r.status, r.statusText);
				window.LOG?.debug?.('Raw response text (first 500 chars):', responseText.substring(0, 500));

				if (!r.ok) {
					// Parse error response
					let errorData;
					try {
						errorData = JSON.parse(responseText);
					} catch (e) {
						errorData = { message: `HTTP ${r.status}: ${r.statusText}` };
					}
					window.LOG?.warn?.('API returned error:', errorData);
					window.LOG?.groupEnd?.();
					// Reject with parsed error data
					return Promise.reject(errorData);
				}

				// Success - parse JSON
				return JSON.parse(responseText);
			})
			.then(data => {
				window.LOG?.success?.('API Success! Items added to cart.');
				window.LOG?.debug?.('Full response data:', data);
				window.LOG?.groupEnd?.();
				McShopify.customEvent(window.MCEVENTS.CART_UPDATED, data);
				McShopify.customEvent(window.MCEVENTS.CART_ADDED, data);
				if (typeof onSuccess === 'function') onSuccess(data);
			})
			.catch(error => {
				window.LOG?.warn?.('Catch block - error:', error);
				window.LOG?.groupEnd?.();
				if (typeof onError === 'function') onError(error);
			})
			.finally(() => {
				if (typeof onComplete === 'function') onComplete();
			});
	}

	// Update cart line
	// Supporta: id, quantity, properties, selling_plan, line
	static updateCartLine({ id, quantity, properties, selling_plan, line, onSuccess, onError, onComplete }) {
		// Costruisci payload con solo i campi definiti
		const payload = {};
		if (id !== undefined) payload.id = id;
		if (quantity !== undefined) payload.quantity = quantity;
		if (properties !== undefined) payload.properties = properties;
		if (selling_plan !== undefined) payload.selling_plan = selling_plan;
		if (line !== undefined) payload.line = line;

		window.LOG?.group?.('[McShopify] updateCartLine');
		window.LOG?.info?.('Payload being sent to /cart/change.js:', payload);
		window.LOG?.debug?.('URL:', `${window.getShopifyRoot()}cart/change.js`);

		fetch(`${window.getShopifyRoot()}cart/change.js`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		})
			.then(async r => {
				const responseText = await r.text();
				window.LOG?.debug?.('Raw response status:', r.status, r.statusText);
				window.LOG?.debug?.('Raw response text (first 500 chars):', responseText.substring(0, 500));
				
				if (!r.ok) {
					// Parse error response per estrarre description da Shopify
					let errorData;
					try {
						errorData = JSON.parse(responseText);
					} catch (e) {
						errorData = { message: `HTTP ${r.status}: ${r.statusText}` };
					}
					window.LOG?.warn?.('API returned error:', errorData);
					window.LOG?.groupEnd?.();
					// Reject with parsed error data (contiene description)
					return Promise.reject(errorData);
				}
				
				// Success - parse JSON
				return JSON.parse(responseText);
			})
			.then(data => {
				window.LOG?.success?.('API Success! Cart updated.');
				window.LOG?.debug?.('Full response data:', data);
				window.LOG?.groupEnd?.();
				McShopify.customEvent(window.MCEVENTS.CART_UPDATED, data);
				if (typeof onSuccess === 'function') onSuccess(data);
			})
			.catch(error => {
				window.LOG?.warn?.('Catch block - error:', error);
				window.LOG?.groupEnd?.();
				if (typeof onError === 'function') onError(error);
			})
			.finally(() => {
				if (typeof onComplete === 'function') onComplete();
			});
	}
}

window.McShopify = McShopify;

// =============================================================================
// Theme Initialization
// =============================================================================
window.theme = window.theme || {};
window.theme.settings = window.theme.settings || {};

// Assicura che window.theme e window.theme.settings esistano
const debugMode =
	window.theme && window.theme.settings && typeof window.theme.settings.debug_mode !== "undefined"
		? Number(window.theme.settings.debug_mode) // Assicura che sia un numero
		: 0; // Default a 0 (Nessuno) se non definito

if (debugMode === 2) {
	//  CODICE DI DEBUG PER window.dispatchEvent ---
	// Conserva una referenza alla funzione originale
	const originalWindowDispatchEvent = window.dispatchEvent;

	// Sovrascrivi window.dispatchEvent
	const _dbg = 'background:#6c757d;color:#fff;padding:1px 6px;border-radius:3px;font-weight:bold;font-size:11px;';
	window.dispatchEvent = function (event) {
		console.groupCollapsed('%c FF %c 🐞 window.dispatchEvent: ' + event.type, _dbg, '');
		console.log('Evento:', event);
		console.log('Dettagli evento (event.detail):', event.detail);
		console.trace('Stack trace della chiamata a dispatchEvent');
		console.groupEnd();

		// Chiama la funzione originale per mantenere il comportamento standard
		return originalWindowDispatchEvent.apply(this, arguments);
	};

	console.log('%c FF %c 🐞 Monitoraggio di window.dispatchEvent attivato', _dbg, '');
}

// =============================================================================
// LOG - Sistema di Logging Avanzato per Debug
// =============================================================================
//
// Utilizzo:
//   window.LOG(...args)           - Log base (rispetta debugMode)
//   window.LOG.debug(...args)     - Log di debug dettagliato (solo debugMode >= 1)
//   window.LOG.info(...args)      - Log informativo (solo debugMode >= 1)
//   window.LOG.warn(...args)      - Warning con stile arancione (solo debugMode >= 1)
//   window.LOG.success(...args)   - Log di successo con stile verde (solo debugMode >= 1)
//   window.LOG.error(...args)     - Errore con stile rosso (SEMPRE ATTIVO, ignora debugMode)
//   window.LOG.time(label)        - Avvia un timer per misurare performance
//   window.LOG.timeEnd(label)     - Termina il timer e logga il tempo trascorso
//   window.LOG.group(label)       - Apre un gruppo di log collassabile
//   window.LOG.groupEnd()         - Chiude il gruppo corrente
//   window.LOG.table(data)        - Visualizza dati tabellari (array/oggetti)
//   window.LOG.trace(...args)     - Log con stack trace completo
//
// Livelli di debug (impostabili da Theme Settings > debug_mode):
//   0 = Nessuno   - Tutti i log sono disabilitati (LOG.error resta attivo)
//   1 = Semplice  - Badge [FF] colorato + icona + messaggio
//   2 = Completo  - Badge [FF] + icona + timestamp + caller + messaggio
//
// Badge colorati (distinguono i log del tema da quelli di terze parti):
//   LOG()        → navy    #1a1a2e   LOG.time()    → viola   #6f42c1
//   LOG.debug()  → grigio  #6c757d   LOG.group()   → ciano   #0891b2
//   LOG.info()   → blu     #0d6efd   LOG.table()   → indaco  #6366f1
//   LOG.warn()   → arancio #e67e22   LOG.trace()   → ardesia #64748b
//   LOG.success()→ verde   #198754   LOG.error()   → rosso   #dc3545
//
// =============================================================================

(function() {
	'use strict';

	// Cache per i timer attivi
	const timers = new Map();
	
	// Contatore per i gruppi aperti (per evitare gruppi non chiusi)
	let openGroups = 0;

	// ── Stili badge per distinguere i log del tema da quelli di terze parti ──
	const RESET = '';
	const _b = (bg) => `background:${bg};color:#fff;padding:1px 6px;border-radius:3px;font-weight:bold;font-size:11px;`;
	const BADGE         = _b('#1a1a2e'); // base: navy scuro
	const BADGE_DEBUG   = _b('#6c757d'); // debug: grigio
	const BADGE_INFO    = _b('#0d6efd'); // info: blu
	const BADGE_WARN    = _b('#e67e22'); // warn: arancione
	const BADGE_SUCCESS = _b('#198754'); // success: verde
	const BADGE_ERROR   = _b('#dc3545'); // error: rosso
	const BADGE_TIME    = _b('#6f42c1'); // time: viola
	const BADGE_GROUP   = _b('#0891b2'); // group: ciano
	const BADGE_TABLE   = _b('#6366f1'); // table: indaco
	const BADGE_TRACE   = _b('#64748b'); // trace: ardesia

	/**
	 * Estrae informazioni sul chiamante dallo stack trace.
	 *
	 * **Performance note**: ogni chiamata istanzia `new Error()` e fa il parsing
	 * dello stack string. In produzione il costo è zero perché `debugMode` è 0
	 * (LOG.debug/info/warn ritornano immediatamente senza chiamare questa funzione).
	 * In sviluppo (debugMode 2) evitare di chiamare LOG.* in hot render loops
	 * o handler scroll/resize ad alta frequenza, poiché ogni invocazione avvia
	 * una micro-allocazione nello heap.
	 *
	 * @returns {string} Nome della funzione/file chiamante
	 */
	function getCallerInfo() {
		try {
			const err = new Error();
			const stack = err.stack || '';
			const stackLines = stack.split('\n');
			
			// Salta le prime 3 righe (Error, getCallerInfo, LOG.*)
			if (stackLines.length > 3 && stackLines[3]) {
				const callerLine = stackLines[3].trim();
				const funcMatch = callerLine.match(/^at\s+(?:new\s+)?([\w$.<>]+(?:\[as\s+[\w$.<>]+\])?)/);

				if (funcMatch && funcMatch[1]) {
					let caller = funcMatch[1];
					const fileMatch = callerLine.match(/\(([^)]+:\d+:\d+)\)/);
					if (fileMatch && fileMatch[1]) {
						let filePath = fileMatch[1];
						let shortFilePath = filePath.substring(filePath.lastIndexOf('/') + 1);
						const queryIdx = shortFilePath.indexOf('?');
						if (queryIdx !== -1) shortFilePath = shortFilePath.substring(0, queryIdx);
						caller += ` (${shortFilePath})`;
					}
					return caller;
				} else {
					const fileMatch = callerLine.match(/at\s+([^\s(]+:\d+:\d+)/);
					if (fileMatch && fileMatch[1]) {
						let filePath = fileMatch[1];
						let shortFilePath = filePath.substring(filePath.lastIndexOf('/') + 1);
						const queryIdx = shortFilePath.indexOf('?');
						if (queryIdx !== -1) shortFilePath = shortFilePath.substring(0, queryIdx);
						return shortFilePath;
					}
				}
			}
		} catch (e) {
			// Fallback silenzioso
		}
		return 'unknown';
	}

	/**
	 * Formatta il timestamp corrente
	 * @returns {string} Timestamp in formato HH:MM:SS.mmm
	 */
	function getTimestamp() {
		const now = new Date();
		const hours = String(now.getHours()).padStart(2, '0');
		const minutes = String(now.getMinutes()).padStart(2, '0');
		const seconds = String(now.getSeconds()).padStart(2, '0');
		const ms = String(now.getMilliseconds()).padStart(3, '0');
		return `${hours}:${minutes}:${seconds}.${ms}`;
	}

	/**
	 * Funzione di log principale
	 * @param {...any} args - Argomenti da loggare
	 */
	function LOG(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.log('%c FF %c 🚀', BADGE, RESET, ...args);
			return;
		}

		// debugMode === 2: Log completo con caller info
		const caller = getCallerInfo();
		console.log('%c FF %c 🚀 [' + caller + ']', BADGE, RESET, ...args);
	}

	/**
	 * Log di debug dettagliato con emoji 🔍
	 * Ideale per: ispezione variabili, stato interno, valori intermedi
	 * @param {...any} args - Argomenti da loggare
	 */
	LOG.debug = function(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.log('%c FF %c 🔍', BADGE_DEBUG, RESET, ...args);
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();
		console.log('%c FF %c 🔍 [' + timestamp + '] [' + caller + ']', BADGE_DEBUG, RESET, ...args);
	};

	/**
	 * Log informativo con emoji ℹ️
	 * Ideale per: eventi importanti, cambio di stato, inizializzazioni
	 * @param {...any} args - Argomenti da loggare
	 */
	LOG.info = function(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.log('%c FF %c ℹ️', BADGE_INFO, RESET, ...args);
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();
		console.log('%c FF %c ℹ️ [' + timestamp + '] [' + caller + ']', BADGE_INFO, RESET, ...args);
	};

	/**
	 * Log di warning con emoji ⚠️ e stile giallo
	 * Ideale per: situazioni potenzialmente problematiche, deprecazioni
	 * @param {...any} args - Argomenti da loggare
	 */
	LOG.warn = function(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.warn('%c FF %c ⚠️', BADGE_WARN, RESET, ...args);
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();
		console.warn('%c FF %c ⚠️ [' + timestamp + '] [' + caller + ']', BADGE_WARN, RESET, ...args);
	};

	/**
	 * Log di successo con emoji ✅ e stile verde
	 * Ideale per: operazioni completate, conferme, validazioni riuscite
	 * @param {...any} args - Argomenti da loggare
	 */
	LOG.success = function(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.log('%c FF %c ✅', BADGE_SUCCESS, RESET, ...args);
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();
		console.log('%c FF %c ✅ [' + timestamp + '] [' + caller + ']', BADGE_SUCCESS, RESET, ...args);
	};

	/**
	 * Log di errore con emoji ❌ - SEMPRE ATTIVO (ignora debugMode)
	 * Decodifica automaticamente oggetti Error, response Shopify, e strutture complesse
	 * Non va MAI in errore - degrada silenziosamente a console.error base
	 * @param {...any} args - Argomenti da loggare (Error, oggetti, stringhe)
	 */
	LOG.error = function(...args) {
		try {
			// Decodifica gli argomenti per estrarre informazioni utili
			const decodedArgs = args.map(arg => {
				try {
					// Oggetto Error nativo
					if (arg instanceof Error) {
						return {
							type: 'Error',
							name: arg.name,
							message: arg.message,
							stack: arg.stack
						};
					}
					
					// Oggetto con proprietà description (errori Shopify API)
					if (arg && typeof arg === 'object' && arg.description) {
						return {
							type: 'ShopifyError',
							description: arg.description,
							message: arg.message || arg.description,
							status: arg.status,
							raw: arg
						};
					}
					
					// Oggetto con proprietà message
					if (arg && typeof arg === 'object' && arg.message) {
						return {
							type: 'ErrorObject',
							message: arg.message,
							raw: arg
						};
					}
					
					// Response fetch fallita
					if (arg && typeof arg === 'object' && typeof arg.status === 'number' && typeof arg.statusText === 'string') {
						return {
							type: 'FetchResponse',
							status: arg.status,
							statusText: arg.statusText,
							url: arg.url
						};
					}
					
					// Restituisci l'argomento originale se non è un tipo speciale
					return arg;
				} catch (e) {
					// Se la decodifica fallisce, restituisci l'originale
					return arg;
				}
			});

			// Prova a loggare con informazioni estese
			const caller = getCallerInfo();
			const timestamp = getTimestamp();
			console.error('%c FF %c ❌ [' + timestamp + '] [' + caller + ']', BADGE_ERROR, RESET, ...decodedArgs);

		} catch (e) {
			// Fallback assoluto: console.error base con gli argomenti originali
			try {
				console.error('%c FF %c ❌', BADGE_ERROR, RESET, ...args);
			} catch (e2) {
				// Ultimo tentativo: console.error senza emoji
				console.error(...args);
			}
		}
	};

	/**
	 * Avvia un timer per misurare performance
	 * @param {string} label - Etichetta identificativa del timer
	 * @example
	 * LOG.time('fetchProducts');
	 * await fetchProducts();
	 * LOG.timeEnd('fetchProducts'); // ⏱️ fetchProducts: 234.56ms
	 */
	LOG.time = function(label) {
		if (debugMode === 0) return;

		timers.set(label, performance.now());

		if (debugMode === 2) {
			const caller = getCallerInfo();
			console.log('%c FF %c ⏱️ [' + caller + '] Timer "' + label + '" avviato', BADGE_TIME, RESET);
		}
	};

	/**
	 * Termina un timer e logga il tempo trascorso
	 * @param {string} label - Etichetta del timer da terminare
	 */
	LOG.timeEnd = function(label) {
		if (debugMode === 0) return;

		const startTime = timers.get(label);
		if (!startTime) {
			if (debugMode >= 1) {
				console.warn('%c FF %c ⚠️ Timer "' + label + '" non trovato', BADGE_WARN, RESET);
			}
			return;
		}

		const elapsed = performance.now() - startTime;
		timers.delete(label);

		// Colore basato sulla durata (verde < 100ms, giallo < 500ms, rosso >= 500ms)
		let timeColor = '#22c55e'; // verde
		if (elapsed >= 500) timeColor = '#ef4444'; // rosso
		else if (elapsed >= 100) timeColor = '#eab308'; // giallo

		if (debugMode === 1) {
			console.log('%c FF %c ⏱️ %c' + label + ': ' + elapsed.toFixed(2) + 'ms', BADGE_TIME, RESET, 'color:' + timeColor + ';font-weight:bold;');
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();

		console.log(
			'%c FF %c ⏱️ %c[' + timestamp + '] [' + caller + '] ' + label + ': ' + elapsed.toFixed(2) + 'ms',
			BADGE_TIME, RESET, 'color:' + timeColor + ';font-weight:bold;'
		);
	};

	/**
	 * Apre un gruppo di log collassabile
	 * @param {string} label - Titolo del gruppo
	 * @example
	 * LOG.group('Inizializzazione carrello');
	 * LOG.info('Caricamento prodotti...');
	 * LOG.debug('Prodotti:', products);
	 * LOG.groupEnd();
	 */
	LOG.group = function(label) {
		if (debugMode === 0) return;

		openGroups++;

		if (debugMode === 1) {
			console.groupCollapsed('%c FF %c 📁 ' + label, BADGE_GROUP, RESET);
			return;
		}

		const caller = getCallerInfo();
		const timestamp = getTimestamp();
		console.groupCollapsed('%c FF %c 📁 [' + timestamp + '] [' + caller + '] ' + label, BADGE_GROUP, RESET);
	};

	/**
	 * Chiude il gruppo di log corrente
	 */
	LOG.groupEnd = function() {
		if (debugMode === 0) return;
		
		if (openGroups > 0) {
			console.groupEnd();
			openGroups--;
		}
	};

	/**
	 * Visualizza dati in formato tabella
	 * Ideale per: array di oggetti, confronti, liste di dati strutturati
	 * @param {Array|Object} data - Dati da visualizzare in tabella
	 * @param {string} [label] - Etichetta opzionale per la tabella
	 * @example
	 * LOG.table([
	 *   { id: 1, name: 'Product A', price: 100 },
	 *   { id: 2, name: 'Product B', price: 200 }
	 * ], 'Prodotti nel carrello');
	 */
	LOG.table = function(data, label) {
		if (debugMode === 0) return;

		if (label) {
			if (debugMode === 2) {
				const caller = getCallerInfo();
				console.log('%c FF %c 📊 [' + caller + '] ' + label, BADGE_TABLE, RESET);
			} else {
				console.log('%c FF %c 📊 ' + label, BADGE_TABLE, RESET);
			}
		}
		console.table(data);
	};

	/**
	 * Log con stack trace completo
	 * Ideale per: debug di flussi complessi, tracciamento chiamate
	 * @param {...any} args - Argomenti da loggare
	 */
	LOG.trace = function(...args) {
		if (debugMode === 0) return;

		if (debugMode === 1) {
			console.log('%c FF %c 🔎', BADGE_TRACE, RESET, ...args);
			console.trace();
			return;
		}

		const timestamp = getTimestamp();
		console.log('%c FF %c 🔎 [' + timestamp + ']', BADGE_TRACE, RESET, ...args);
		console.trace();
	};

	/**
	 * Chiude tutti i gruppi aperti (utile in caso di errori)
	 * Chiamato automaticamente in caso di eccezioni non gestite
	 */
	LOG.closeAllGroups = function() {
		while (openGroups > 0) {
			console.groupEnd();
			openGroups--;
		}
	};

	// Esponi LOG globalmente
	window.LOG = LOG;

})();

// ============================================================================
// GLOBAL ERROR HANDLERS
// Cattura errori JS non gestiti e Promise rejection non gestite.
// Unifica: chiude i gruppi LOG aperti E logga l'errore nello stesso handler,
// evitando race condition visiva tra due listener separati.
// Usa window.LOG.error (sempre attivo) con fallback a console.error.
// ============================================================================

window.addEventListener('error', (event) => {
	// Chiudi eventuali gruppi LOG rimasti aperti prima di loggare l'errore
	window.LOG?.closeAllGroups?.();
	const msg = `[GlobalError] ${event.message}`;
	const detail = `${event.filename}:${event.lineno}:${event.colno}`;
	if (window.LOG?.error) {
		window.LOG.error(msg, detail, event.error);
	} else {
		console.error(msg, detail, event.error);
	}
});

window.addEventListener('unhandledrejection', (event) => {
	window.LOG?.closeAllGroups?.();
	const msg = '[UnhandledRejection]';
	if (window.LOG?.error) {
		window.LOG.error(msg, event.reason);
	} else {
		console.error(msg, event.reason);
	}
});




const BREAKPOINT_CSS_VARIABLES = {
	md: '--screen-md'
};

const breakpointCache = new Map();

/**
 * Recupera e normalizza il valore di una variabile CSS di root
 * @param {string} variableName
 * @returns {string}
 */
function getCssVariableValue(variableName) {
	if (typeof window === 'undefined') {
		return '';
	}

	const root = document.documentElement;
	if (!root) {
		return '';
	}

	const value = getComputedStyle(root).getPropertyValue(variableName);
	return value ? value.trim() : '';
}

/**
 * Risolve il valore del breakpoint richiesto usando le variabili CSS generate da Tailwind
 * @param {string} name
 * @param {string} fallback
 * @returns {string}
 */
function resolveCssBreakpoint(name, fallback = '') {
	if (breakpointCache.has(name)) {
		return breakpointCache.get(name);
	}

	const variableName = BREAKPOINT_CSS_VARIABLES[name];
	if (!variableName) {
		return fallback;
	}

	const value = getCssVariableValue(variableName) || fallback;
	if (value) {
		breakpointCache.set(name, value);
	}
	return value;
}

if (!window.theme.breakpoints) {
	window.theme.breakpoints = {
		/**
		 * Restituisce il valore raw del breakpoint (es. '1024px')
		 * @param {string} name
		 * @param {string} fallback
		 * @returns {string}
		 */
		get(name, fallback = '') {
			return resolveCssBreakpoint(name, fallback);
		},

		/**
		 * Restituisce una MediaQueryList pronta basata sul breakpoint richiesto
		 * @param {string} name
		 * @param {{type?: 'min' | 'max', fallback?: string}} [options]
		 * @returns {MediaQueryList | null}
		 */
		matchMedia(name, options = {}) {
			if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
				return null;
			}

			const { type = 'min', fallback = '' } = options;
			const value = resolveCssBreakpoint(name, fallback);
			if (!value) {
				return null;
			}

			return window.matchMedia(`(${type}-width: ${value})`);
		}
	};
}





async function themeComponent(url, lazyLoad = true, checkDom = false) {
	const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('res-', '').replace('.js', '');
	// camelizza il nome del tag e metti in maiuscolo la prima lettera
	const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());

	// se il tag è già definito non lo carico
	if (window[className] !== undefined) {
		return;
	}

	// se devo controllare il dom e non trovo il tag non lo carico
	if (checkDom && document.querySelector(tagName) == null) {
		return;
	}

	if (lazyLoad) {
		import(url).catch(e => {
			// Usa LOG.error se disponibile (già attivo in prod), altrimenti fallback a console.error.
			// NON usare (??) sul ritorno di LOG.error: ritorna undefined → il fallback scatterebbe sempre.
			if (window.LOG?.error) {
				window.LOG.error(`[themeComponent] Errore nel caricamento del componente ${tagName}:`, e);
			} else {
				console.error(`[themeComponent] Errore nel caricamento del componente ${tagName}:`, e);
			}
		});
	} else {
		await import(url);
	}
}
window.themeComponent = themeComponent;